// @flow
import * as React from 'react';
import styled from 'styled-components';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import smoothscroll from 'smoothscroll-polyfill';
import _ from 'lodash';
import colors from '../../../assets/css/colors';
import { below } from "../../../assets/css/media";
import  ArrowRight from '../../../components/Icons/ArrowRight';
import   ArrowLeft from '../../../components/Icons/ArrowLeft';
import {
	RotatedLabel,
} from '../../../components';
import type { TRootStore } from "../../../modules/types";
import * as selectors from "../../../modules/selectors";
import type { TUser } from "../../../modules/types/user";
import DraftTeamListOrderItem from "./draftTeamListOrderItem";

smoothscroll.polyfill();

const DraftTeamListOrderIndicatorWrapper = styled.div`
	width: 100%;
	position: relative;
	overflow: hidden;
	display: flex;
	justify-content: space-between;
	padding: 10px 0;
	margin: -10px 0;

	> div {
		overflow: hidden;
		margin: -10px 0;
		position: relative;

		&:before {
			content: '';
			display: block;
			position: absolute;
			top: 10px;
			left: 0;
			z-index: 2;
			height: calc(100% - 20px);
			width: 8px;
			background-image: linear-gradient(to right, rgba(0, 0,0,1), rgba(0, 0, 0, 0));
			opacity: 0.1;
		}

		&:after {
			content: '';
			display: block;
			position: absolute;
			top: 10px;
			right: 0;
			z-index: 2;
			height: calc(100% - 20px);
			width: 8px;
			background-image: linear-gradient(to left, rgba(0, 0,0,1), rgba(0, 0, 0, 0));
			opacity: 0.1;
		}

	}

	ul {
		display: flex;
		position: relative;
		margin: 0;
		padding: 10px 0;
		list-style: none;
		overflow: hidden;

		li {
		  position: relative;
		  display: block;
		  float: left;
		  margin: 0;
		  padding: 0;
		  width: 80px;
		  min-width: 80px;
		  flex-basis: 80px;
		  height: 80px;
		  background: #ccc;
		  text-align: center;
		  flex-shrink: 0;
		  transform: scale(1);

		  &.active{
			  transform: scale(1.05);
			  z-index: 2;
		  }
		}
	}

	${below.desktop`
		display: none !important;
	`};
`;

const ArrowButton = styled.button`
		height: 80px;
		width: 25px;
		background: #F6F6F6;
		text-decoration: none;
		font-weight: 600;
		font-size: 18px;
		opacity: 0.8;
		cursor: pointer;
		color:${colors.nrlDarkGreen};
		display: flex;
		align-items: center;
		justify-content: center;
		border: 0;

		> svg {
			height: 15px;
			width: 15px;
		}

		&:hover{
			opacity: 1;
			transition: all 0.2s ease;
		}
		
		&:focus {
			outline: 0;
		}

`;

const RoundNumberDevider = styled(RotatedLabel)`
	height: 80px;

	> div {
		color:#777777;
		font-size: 10px;
		font-weight: bold;
		white-space: nowrap;
	}
	> div > div {
		white-space: nowrap;
	}
`;

const RoundDeviderLi = styled.li`
	width: auto !important;
	min-width: 0 !important;
	flex-basis: auto !important;
`;


type Props = {
	currentPick?: Object,
	draft_order: Array<Object>,
	user: TUser,
	isMyTurn: boolean,
};

class DraftTeamListOrderIndicatorContainer extends React.Component<Props> {
	last_pick = 1;
	visible_elements_size = 0;
	total_picks = 0;
	list = React.createRef();
	scrollLeft: Function;
	scrollRight: Function;

	componentDidMount(){
		this.scrollLeft = this.onClickScrollControl.bind(this, -1);
		this.scrollRight = this.onClickScrollControl.bind(this, 1);
	}

	componentDidUpdate() {
		const { currentPick, draft_order } = this.props;
		const new_pick = _.get(currentPick, 'pick', this.last_pick);
		this.last_pick = Math.max(1, Math.min(new_pick, new_pick - 3));

		if(!this.total_picks) {
			this.total_picks = _.size(draft_order.filter(_.negate(_.property('is_label'))));
		}

		this.updateSliderPosition();
	}

	updateSliderPosition(){
		const element = document.getElementById(`pick-item-${this.last_pick}`);
		const list = this.list.current;

		if(element && list) {
			const offset = element.offsetLeft - 20;

			try {
				list.scroll({
					top: 0,
					left: offset,
					behavior: 'smooth',
				});
			}
			catch(err) {
				list.scrollLeft = offset;
			}
		}
	}

	onClickScrollControl(direction){
		if(!this.visible_elements_size) {
			const elem = document && document.getElementById('pick-item-1');
			const list = this.list.current;

			if(elem && list) {
				const container_width = list.offsetWidth || list.clientWidth;
				const elem_width = elem.offsetWidth || elem.clientWidth;
				this.visible_elements_size = parseInt(container_width / elem_width, 10);
			}
		}

		this.last_pick = Math.max(1, Math.min(
			this.last_pick + direction * this.visible_elements_size,
			this.total_picks
		));

		this.updateSliderPosition();
	}

	render() {
		const {
			currentPick,
			draft_order,
			user,
			isMyTurn,
		} = this.props;

		const curr_pick = _.get(currentPick, 'pick');

		return currentPick ? (
			<DraftTeamListOrderIndicatorWrapper >
				<ArrowButton onClick={this.scrollLeft}>
					<ArrowLeft />
				</ArrowButton>
				<div>
					<ul ref={this.list}>
						{ draft_order.map(({ pick, ...item }, index) => item.is_label ? (
							<RoundDeviderLi key={index}>
								<RoundNumberDevider
									text={`Round ${item.round_id}`}
									rotate="-90"
									color="#777777"
									background="#E5EBEA"
								/>
							</RoundDeviderLi>
						) : (
							<li
								id={`pick-item-${pick}`}
								key={index}
								className={`pick-item ${_.eq(pick, curr_pick) ? 'active' : ''}`}
							>
								<DraftTeamListOrderItem
									team_name={item.name}
									first_name={item.firstname}
									user_id={item.user_id}
									pick_number={pick}
									this_is_you={_.eq(item.user_id, user.id)}
									is_your_pick={_.eq(pick, curr_pick) && isMyTurn}
									current_pick_number={curr_pick}
									is_past_pick={pick < curr_pick}
								/>
							</li>
						)) }
					</ul>
				</div>
				<ArrowButton onClick={this.scrollRight}>
					<ArrowRight />
				</ArrowButton>
			</DraftTeamListOrderIndicatorWrapper>
		) : null;
	}
}

const mapStateToProps = (state: TRootStore, props) => ({
	draft_order: selectors.leagueDraft.getDraftOrder(state, props),
	user: selectors.getUser(state),
});

export const DraftTeamListOrderIndicator = withRouter(
	connect(mapStateToProps)(DraftTeamListOrderIndicatorContainer)
);

export default DraftTeamListOrderIndicator;


// WEBPACK FOOTER //
// ./src/pages/league/liveDraft/draftTeamListOrderIndicator.js